import { useEffect, useState } from "react";
import api from "../lib/api";

let cache = null;
let inflight = null;

/**
 * Returns customer-safe business settings (tax rate, mileage, deposit, etc.)
 * from `GET /api/settings/public`. Cached in-module after the first successful
 * fetch so repeated callers don't refetch on each render/navigation.
 */
export function usePublicSettings() {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    if (cache) {
      setSettings(cache);
      return;
    }
    if (!inflight) {
      inflight = api
        .get("/settings/public")
        .then((r) => { cache = r.data; return r.data; })
        .catch(() => null)
        .finally(() => { inflight = null; });
    }
    let cancelled = false;
    inflight.then((data) => { if (!cancelled && data) setSettings(data); });
    return () => { cancelled = true; };
  }, []);

  return settings;
}

export function clearPublicSettingsCache() {
  cache = null;
}
